import React from 'react';
import { useTranslation } from 'react-i18next';
import './EmployeeSessionBanner.css';

const EmployeeSessionBanner: React.FC = () => {
  const { t } = useTranslation('common');
  const isEmployeeSession = localStorage.getItem('isEmployeeSession') === 'true';
  const employeeName = localStorage.getItem('employeeName');

  if (!isEmployeeSession) {
    return null;
  }

  return (
    <div className='employee-session-banner'>
      <div className='banner-content'>
        <div className='banner-icon'>👤</div>
        <div className='banner-text'>
          <strong>{t('employeeSession.title')}</strong>
          <span>{t('employeeSession.connectedAs', { name: employeeName })}</span>
        </div>
      </div>
    </div>
  );
};

export default EmployeeSessionBanner;
